import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56e0ff1e")

_pushScopeId("data-v-56e0ff1e")
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "level" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "Edit draft registration", -1)
const _hoisted_5 = {
  key: 1,
  class: "message is-danger"
}
const _hoisted_6 = { class: "message-body" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", { class: "is-third is-centered" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_dirty_tracker = _resolveComponent("dirty-tracker")
  const _component_EditActions = _resolveComponent("EditActions")
  const _component_EditForm = _resolveComponent("EditForm")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.save(true)), ["prevent"])),
      id: _ctx.formId,
      novalidate: ""
    }, [
      (_ctx.isDirtyTrackingEnabled)
        ? (_openBlock(), _createBlock(_component_dirty_tracker, {
            key: _ctx.registration?.id,
            tracked: _ctx.registration
          }, null, 8, ["tracked"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1),
          _hoisted_4
        ]),
        _createVNode("div", null, [
          _createVNode(_component_EditActions, {
            onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelEdit())),
            disabled: _ctx.disableActions
          }, null, 8, ["disabled"])
        ])
      ]),
      (_ctx.hasErrors)
        ? (_openBlock(), _createBlock("article", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      (_ctx.registration)
        ? (_openBlock(), _createBlock(_component_EditForm, {
            key: 2,
            modelValue: _ctx.registration,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.registration = $event)),
            "onUpdate:files": _ctx.updateFiles,
            onFileUploaded: _ctx.onFileUploaded,
            onFileDeleted: _ctx.onFileDeleted,
            onUploading: _cache[4] || (_cache[4] = ($event: any) => (_ctx.disableActions = $event))
          }, null, 8, ["modelValue", "onUpdate:files", "onFileUploaded", "onFileDeleted"]))
        : _createCommentVNode("", true),
      _createVNode(_component_EditActions, {
        onSave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save())),
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelEdit())),
        disabled: _ctx.disableActions
      }, null, 8, ["disabled"])
    ], 40, ["id"])
  ]))
})